import { addError, addSuccess } from '@/store/reducers/ToastStore';
import { isBrowser } from '@/utils/env';
import { mkCopyLinkBtnTrackAttrs } from '@/analytics/props/shareThread';
import { ThreadId } from '@/models/Thread';
import { useAppDispatch } from '@/store/hooks';

import { alpha, Button, styled } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';

type ShareThreadButtonProps = {
  threadId: ThreadId;
};

export const ShareThreadButton = ({ threadId }: ShareThreadButtonProps) => {
  const dispatch = useAppDispatch();

  const shareUrl = isBrowser()
    ? `${window.location.origin}/share/${threadId}`
    : `https://nora.allen.ai/share/${threadId}`;

  const copyShareLinkToClipboard = async () => {
    if (!navigator.clipboard) {
      return;
    }

    try {
      await navigator.clipboard.writeText(shareUrl);
      dispatch(addSuccess({ text: 'Link copied to clipboard' }));
    } catch (error) {
      dispatch(addError({ text: 'Error copying share link to clipboard' }));
    }
  };

  return (
    <ShareButton
      variant="outlined"
      endIcon={<IosShareIcon />}
      {...mkCopyLinkBtnTrackAttrs()}
      onClick={copyShareLinkToClipboard}
    >
      Share
    </ShareButton>
  );
};

const ShareButton = styled(Button)`
  &.MuiButton-outlined {
    border: 1px solid ${({ theme }) => alpha(theme.palette.secondary.main, 0.2)};
    margin-left: ${({ theme }) => theme.spacing(1)};
    padding: ${({ theme }) => theme.spacing(0.5, 1)};

    &:hover {
      border: 1px solid
        ${({ theme }) => alpha(theme.palette.secondary.main, 0.4)};
    }
  }
`;
